export const environment = {
  production: false,
  apiUrl: 'http://localhost:8080',
  environment: 'development',
  version: '1.0.0-dev',
  debug: true,
  logLevel: 'debug',
};
